import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { appSettings } from 'app/appSettings';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { FlowFilterValuesLoadGuard } from 'app/core/guards/flow-filter-values-load.guard';
import { ClearFlowsFilterGuard } from '../../core/store/flows/flows-clear.resolve';
import { FlowsExecuteCleanFilterGuard } from '../../core/store/flows/flows-execute-clean-filter.resolve';
import { FlowsFilterQueryGuard } from '../../core/store/flows/flows-filter-query.resolve';
import { RefreshFlowsFilterGuard } from '../../core/store/flows/flows-refresh.resolve';
import { FlowPageContainer } from './flow-page-container/flow-page.container';

const routes: Routes = [
  {
    path: 'flows',
    component: FlowPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [FlowFilterValuesLoadGuard],
    },
  },
  {
    path: 'flows/openHandshakes',
    component: FlowPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [FlowsFilterQueryGuard],
      filter: {
        florderDateFrom: null,
        flowStatuses: [
          appSettings.FLOW_STATUS_WAITING_FOR_HANDSHAKE,
          appSettings.FLOW_STATUS_WAITING_FOR_SUPPLIER_REGISTRATION,
          appSettings.FLOW_STATUS_WAITING_FOR_DISPUTE_MANAGEMENT,
        ],
      },
    },
  },
  {
    path: 'flows/diffHandshakes',
    component: FlowPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [FlowsFilterQueryGuard],
      filter: {
        florderDateFrom: null,
        flowStatuses: [appSettings.FLOW_STATUS_HANDSHAKE_WITH_DIFFERENCE],
      },
    },
  },
  {
    path: 'flows/refresh',
    component: FlowPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [RefreshFlowsFilterGuard],
    },
  },
  {
    path: 'flows/execute-clean-filter',
    component: FlowPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [FlowsExecuteCleanFilterGuard],
    },
  },
  {
    path: 'flows/clear',
    component: FlowPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [ClearFlowsFilterGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlowsRoutingModule { }
